let BACKEND_SERVER = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {
  BACKEND_SERVER = "http://localhost:5000/api/";
}

// WebSocket URL configuration
const getWebSocketUrl = () => {
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  if (process.env.NODE_ENV === "production") {
    return `wss://api.conciliadirecto.com/ws/`; // URL de producción
  }
  return `${protocol}//localhost:5000/ws/`; // URL de desarrollo
};

export const API_SERVER = BACKEND_SERVER;
export const WS_SERVER = getWebSocketUrl();
